<div
  class="sidebar-container z-50 flex flex-col  shadow-lg px-10 py-5 h-screen md:w-300 w-min overflow-hidden">
  <div class="flex justify-end">
    <i class="pi pi-times md:text-2xl text-xs text-white cursor-pointer my-4 mr-0" (click)="closeSidebar()"></i>
  </div>
  <div class="flex flex-col items-center text-white px-4 py-2 mb-3 ">
    <div class=" flex items-center justify-center mx-5"
      [ngClass]="userData?.profile_photo?'rounded-full w-20 h-20 mb-4 mx-2 bg-white':'' ">
      <img *ngIf="userData?.profile_photo" class="w-full h-full rounded-full" [src]="userData?.profile_photo"
        alt="User profile picture">
      <i *ngIf="!userData?.profile_photo" class="pi pi-user text-2xl text-white"></i>
    </div>
    <div *ngIf="isLoggedIn">
      <h3 class="text-xs text-center text-white">Logged In</h3>
    </div>

    <div *ngIf="!isLoggedIn" class="login">
      <a class="text-white text-lg mx-2" href="" (click)="closeSidebar()" [routerLink]="'/auth'">Login</a>
    </div>
  </div>
  <hr class="border-black mb-3">
  <div class="text-white text-start w-full">
    <ul class="flex flex-col gap-2 font-bold text-sm cursor-pointer">
      <li><a class="" href="" (click)="closeSidebar()" [routerLink]="'/'">Home</a></li>
      <hr class="border-white mb-2">
      <li class="relative" *ngIf="isLoggedIn">
        <a class="h cursor-pointer" (click)="dropdownOpen = !dropdownOpen">
          My Account {{ dropdownOpen ? '▲' : '▼' }}
        </a>
        <ul class="relative left-0 bg-white-alpha-70 text-sm z-10" *ngIf="dropdownOpen">
          <li><a class=" block px-4 py-2" href="" (click)="closeSidebar(); dropdownOpen = false"
              [routerLink]="'/my-account'">My Account</a></li>
          <li><a class=" block px-4 py-2" href="" (click)="closeSidebar(); dropdownOpen = false"
              [routerLink]="'/my-account/orders'">Orders</a></li>
          <li><a class=" block px-4 py-2" href="" (click)="closeSidebar(); dropdownOpen = false"
              [routerLink]="'/my-account/orders'">Raise Query</a></li>
        </ul>
      </li>
      <hr *ngIf="isLoggedIn" class="border-white mb-2">
      <li><a class=" "  (click)="closeSidebar()" [routerLink]="'/products'">Products</a></li>
      <hr class="border-white mb-2">
      <li><a class=" " (click)="closeSidebar()" href="" [routerLink]="'/blogs'">Blogs</a></li>
      <hr class="border-white mb-2">
      <li><a class=" " (click)="openFeedbackModal()">Feedback</a></li>
      <hr class="border-white mb-2">
      <li><a class=" " href="" (click)="closeSidebar()" [routerLink]="'/about-us'">About
          us</a></li>
      <hr class="border-white mb-2">
      <li><a class=" " href="" (click)="closeSidebar()"
          [routerLink]="'/contact-us'">Contact Us</a></li>
      <hr class="border-white mb-2">
      <li><a class=" " href="" (click)="closeSidebar()" [routerLink]="'/faq'">FAQ'S</a></li>
      <hr class="border-white mb-2">
      <li *ngIf="isLoggedIn"><a class="  my-2 bg-black p-2 rounded-lg  " href="" (click)="logout()">Logout</a></li>
    </ul>
  </div>
</div>